// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { PageLinkModel } from "@insite/client-framework/Services/ContentService";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getPageLinkByNodeId, LinkModel } from "@insite/client-framework/Store/Links/LinksSelectors";
import { LinkPresentationProps } from "@insite/mobius/Link";
import ArrowLeft from "@west/XDL/Icons/ArrowLeft";
import ChevronRight from "@west/XDL/Icons/ChevronRight";
import { css } from "styled-components";

export const myAccountMapLinks = (state: ApplicationState, widgetLinks: LinkModel[]): PageLinkModel[] => {
    return (
        (widgetLinks
            ?.map(widgetLink => {
                const pageLink = getPageLinkByNodeId(state, widgetLink.fields.destination.value);
                if (pageLink) {
                    return { ...pageLink, title: widgetLink.fields.overriddenTitle || pageLink?.title };
                }
                return undefined;
            })
            ?.filter(pageLink => !pageLink?.excludeFromNavigation) as PageLinkModel[]) || []
    );
};

export const viewAllStyle: LinkPresentationProps = {
    typographyProps: {
        size: 12,
        weight: "bold",
        css: css`
            letter-spacing: 0;
            line-height: 16px;
        `,
    },
    icon: {
        position: "right",
        iconProps: {
            size: 8,
            src: ChevronRight,
            css: css`
                margin-left: 8px;
                opacity: 0.66;
            `,
        },
    },
};

export const backToLinkStyle: LinkPresentationProps = {
    icon: {
        iconProps: {
            size: 12,
            src: ArrowLeft,
            color: "common.ui8",
            css: css`
                opacity: 0.66;
            `,
        },
    },
    typographyProps: {
        size: 12,
        weight: "bold",
        transform: "initial",
        css: css`
            letter-spacing: 0;
            line-height: 16px;
        `,
    },
};
// used for richContentField in xParserOptions
export const largeLinkFontSize: LinkPresentationProps = {
    typographyProps: {
        css: css`
            font-size: 16px;
        `,
    },
};
